import type { ReactNode } from 'react'
import { twJoin } from '@/lib/utils'

type Props = {
    label: string
    value?: ReactNode
    /** Chú thích nhỏ dưới giá trị (vd giải thích ý nghĩa của trường). */
    hint?: string
    className?: string
    testId?: string
}

/**
 * Một dòng "nhãn — giá trị" ở màn chỉ xem. Cố ý KHÔNG dùng `<input disabled>`:
 * ô nhập xám khiến người dùng tưởng mình sửa được mà bị khoá, trong khi thứ họ
 * cần chỉ là đọc thông tin.
 *
 * Trường trống hiện dấu "—" thay vì để rỗng, để hàng không bị hụt và người đọc
 * biết là "chưa có", không phải lỗi hiển thị.
 */
export function ReadonlyField({
    label,
    value,
    hint,
    className,
    testId,
}: Props) {
    const empty =
        value == null || (typeof value === 'string' && value.trim() === '')

    return (
        <div className={twJoin('space-y-1', className)}>
            <p className="text-xs font-medium text-muted-foreground">{label}</p>
            <p
                data-testid={testId}
                className={twJoin(
                    'text-sm',
                    empty ? 'text-muted-foreground' : 'font-medium',
                )}
            >
                {empty ? '—' : value}
            </p>
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
        </div>
    )
}
